module.exports = __webpack_public_path__ + "images/templates/category-sprite@2x.56e6839e477d82529dad.png";